import "./App.css";
import Header from "./Components/Header.jsx";
import Main from "./Components/Main.jsx";

function App() {
  return (
    <div className="App">
      <Header />
      <Main />
    </div>
  );
}

export default App;
